import { Link, navigate, RouteComponentProps } from "@reach/router";
import React, { useEffect } from "react";
import { useQuery } from "@apollo/client";
import { Grid } from "@material-ui/core";
import { useViewer } from "components/viewer/context";
import { getViewer } from "types/gql-types";
import Settings from "settings";
import { useRedirectPropertiesPageFeature } from "components/feature/use-redirect-properties-page-feature";
import { VIEWER_QUERY } from "components/auth/query";
import LoginModalContext from "components/login/context/modal";
import LoginCard from "./login-card";

const LoginPageCardFooter: React.FC = () => {
  const redirectPropertiesPage = useRedirectPropertiesPageFeature();
  return (
    <Grid item container spacing={0} direction="column" alignItems="center" justifyContent="center">
      <div
        style={{
          textAlign: "center",
          fontSize: 13,
        }}
      >
        <div>
        Looking for housing? &nbsp; &nbsp;
          {redirectPropertiesPage ? (
            <Link to="/properties">View open waiting lists</Link>
          ) : (
            <a href={Settings.whitelabel_server_url} target="_blank" rel="noreferrer">
              View open waiting lists
            </a>
          )}
        </div>
        <div>
            Are you a property manager? &nbsp; &nbsp;
          <a href="https://www.havenconnect.com/request-a-demo" target="_blank" rel="noreferrer">
              Request a demo
          </a>
        </div>
      </div>
    </Grid>
  );
};
type Props = {redirectUrl?: string, isSignup?: boolean}

export const LoginPage: React.FC<RouteComponentProps<Props>> =
({ redirectUrl, isSignup = false }) => {
  const viewer = useViewer();
  const { loading, error, data, refetch } = useQuery<getViewer>(VIEWER_QUERY);

  const query = new URLSearchParams(window.location.search);
  const returnTo = query.get("return-to");

  useEffect(() => {
    if (viewer && data && data.viewer) {
      if (redirectUrl) {
        navigate(redirectUrl);
      } else if (returnTo) {
        navigate(returnTo);
      } else if (data.viewer.isAdmin) {
        navigate("/dash/admin");
      } else if (data.viewer.isClient) {
        navigate("/dash/client/submissions");
      } else if (data.viewer.isSupervisor) {
        navigate("/dash/manager/lists");
      } else if (data.viewer.isPropManager) {
        navigate("/dash/manager/lists");
      }
    }
  }, [viewer, loading, data, error]);

  return (
    <Grid container justifyContent="center" spacing={2} direction="row">
      <Grid item xs={12}> <br /> </Grid>
      <LoginModalContext.Provider value={{ inModal: false }}>
        <LoginCard afterLogin={() => refetch()} isSignup={isSignup} />
      </LoginModalContext.Provider>
      <LoginPageCardFooter />
      <Grid item xs={12}>
        <div style={{ height: "5em" }}/>
      </Grid>
    </Grid>
  );
};
